
export default function isMainnet(): boolean {
  const sn_network = localStorage.getItem("sn_network")
  if (sn_network === 'SN_MAIN') {
    return true
  }
  return  false
}
